import type { ComponentConfig } from '@puckeditor/core'
import ColorField from './ColorField'

export interface ContainerProps {
    children: any
    backgroundColor: string
    padding: number
    borderRadius: number
    borderWidth: number
    borderColor: string
}

export const ContainerBlock: ComponentConfig<ContainerProps> = {
    label: 'Container',
    defaultProps: {
        children: [],
        backgroundColor: 'transparent',
        padding: 16,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: '#E5E7EB',
    },
    fields: {
        children: { type: 'slot', label: 'Content' },
        backgroundColor: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Background Color" value={value === 'transparent' ? '#ffffff' : value} onChange={onChange} />,
        },
        padding: { type: 'number', label: 'Padding', min: 0, max: 100 },
        borderRadius: { type: 'number', label: 'Border Radius', min: 0, max: 100 },
        borderWidth: { type: 'number', label: 'Border Width', min: 0, max: 10 },
        borderColor: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Border Color" value={value} onChange={onChange} />,
        },
    },
    render: ({ children: Children, backgroundColor, padding, borderRadius, borderWidth, borderColor }) => (
        <div style={{
            backgroundColor,
            padding,
            borderRadius,
            border: borderWidth > 0 ? `${borderWidth}px solid ${borderColor}` : 'none',
            width: '100%',
            minHeight: 48,
            boxSizing: 'border-box',
        }}>
            <Children />
        </div>
    ),
}
